import { Model as i } from "../../../../model.js";
class c extends i {
  constructor(t) {
    super(), this.channel = t.channel, this.created = t.created, this.id = t.id, this.location = t.location, this.status = t.status, this.ticketDatetime = t.ticketDatetime, this.ticketId = t.ticketId, this.ticketNumber = t.ticketNumber, this.ticketService = t.ticketService, this.ticketSummary = t.ticketSummary, this.timestamp = t.timestamp, this.scope = t.scope;
  }
}
export {
  c as OrderRecordModel
};
//# sourceMappingURL=order.record.model.js.map
